/** 与导航栏、个人中心等一致的移动端断点 */
export const MOBILE_LAYOUT_MAX_WIDTH = 768

export function isMobileLayoutViewport() {
  return typeof window !== 'undefined' && window.innerWidth <= MOBILE_LAYOUT_MAX_WIDTH
}
